import { ReactNode } from 'react';
import { LocaleText } from '../LocaleText';
import { useStepContext } from '../contexts/stepContext';

export const Footer = ({ goBack = false, children }: { goBack?: boolean; children?: ReactNode }) => {
  const { dispatch, currentStep, nextDefaultStep } = useStepContext();

  const cancelImmediately = nextDefaultStep?.type === 'cancel-flow:cancel-subscription';

  const showCancelAnyway = currentStep?.type !== 'cancel-flow:survey';

  return (
    <div className="og-dialog-footer">
      {goBack && (
        <button className="og-button" data-variant="secondary" onClick={() => dispatch({ type: 'back' })}>
          <LocaleText t="goBack" />
        </button>
      )}
      {showCancelAnyway && (
        <button
          className="og-button"
          data-variant="tertiary"
          onClick={() => dispatch({ type: 'next' })}
          {...(cancelImmediately ? { 'data-state': 'error' } : {})}
        >
          <LocaleText t="continue" />
        </button>
      )}
      {children}
    </div>
  );
};
